export enum CheckoutConversionMetricInformationStatus {
  UNKNOWN = "0",
  KNOWN = "1",
}

/**
 * Which Shopify extension is recording the metric.
 */
export enum CheckoutConversionMetricSource {
  CHECKOUT_UI = "checkout-ui",
  CHECKOUT_OPTIMIZATION_ANALYTICS = "checkout-optimization-analytics",
}
